if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches)
          this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const rect = activeMedia.getBoundingClientRect();
          if (rect.top > -0.5) return;
          window.scrollTo({ top: rect.top + window.scrollY, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', true), 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}  // <-- Datei/Block endet hier. Kein weiteres "});" einfügen!

// === TravBuddies Custom: Fancybox Native Zoom for Images ===
(function() {
  document.addEventListener('click', function(e) {
    if (!window.Fancybox) return;

    // Finde heraus, ob auf ein Produktbild geklickt wurde
    const isModalOpener = e.target.closest('modal-opener.product__modal-opener--image');
    const isSwiperImage = e.target.closest('.product-image-main .swiper-slide img');
    
    // Einige Swiper Slides haben eigene Wrapper, auch diese abfangen
    const isMainImageContainer = e.target.closest('div[data-main-pdp-swiper]');
    
    const targetElement = isModalOpener || isSwiperImage;

    if (targetElement) {
      // Verhindere Dawns und Swipers originales Event
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Sammle alle Bilder für die Galerie
      const allImageNodes = Array.from(document.querySelectorAll('.product-image-main .swiper-slide:not(.swiper-slide-duplicate) img, modal-opener.product__modal-opener--image img'));
      
      let galleryItems = [];
      const addedUrls = new Set();
      let startIndex = 0;

      // Welches Bild wurde genau angeklickt?
      let clickedSrc = '';
      if (e.target.tagName === 'IMG') {
        clickedSrc = e.target.src || e.target.currentSrc;
      } else if (isModalOpener) {
        const img = isModalOpener.querySelector('img');
        if (img) clickedSrc = img.src || img.currentSrc;
      }

      // Bereite hochauflösende Bilder vor
      allImageNodes.forEach((imgNode) => {
        let lowRes = imgNode.src || imgNode.currentSrc || '';
        if (!lowRes) return;
        
        let highRes = lowRes;
        
        // Versuche das bestmögliche, originalauflösende Bild zu grabben
        if (highRes.includes('width=')) {
          highRes = highRes.split('?')[0]; // komplettes original Bild
        }

        if (!addedUrls.has(highRes)) {
          addedUrls.add(highRes);
          galleryItems.push({ src: highRes, type: 'image' });
          
          if (clickedSrc && lowRes === clickedSrc) {
            startIndex = galleryItems.length - 1;
          }
        }
      });

      // Wenn die Bilder-Liste leer ist (Fallback), nimm wenigstens das geklickte
      if (galleryItems.length === 0 && clickedSrc) {
        let hiRes = clickedSrc.includes('width=') ? clickedSrc.split('?')[0] : clickedSrc;
        galleryItems.push({ src: hiRes, type: 'image' });
      }

      // Falls immernoch leer.. abbrechen
      if (galleryItems.length === 0) return;

      // Fancybox wie Kapten & Son starten (Mobile App Feeling)
      window.Fancybox.show(galleryItems, {
        startIndex: Math.max(0, startIndex),
        Images: {
          zoom: true,
          initialSize: "fit"
        },
        Carousel: {
          friction: 0.8
        },
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ["close"],
          },
        }
      });
    }
  }, true); // `true` (Capture) fängt den Klick, bevor die anderen Scripte reagieren können!
})();
